var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification_users" },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                on: { click: _vm.select_user },
              },
              [
                _c("span", { staticClass: "fal fa-eject mr-1" }),
                _vm._v("\n                Обрати користувачів\n            "),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "users_in" }, [
        _c("div", { staticClass: "users_list mt-3" }, [
          _c(
            "ul",
            { staticClass: "user_list_to_insert" },
            _vm._l(_vm.inside_users, function (item, index) {
              return _c(
                "li",
                { staticClass: "border cursor-pointer shadow-1 mt-1 mb-2" },
                [
                  _c("user_block", {
                    key: item.id,
                    attrs: {
                      del_triger: "remove_customer_in_invoice",
                      can_del: true,
                      show_vacation: true,
                      user: item,
                      padding_class: "pt-2 pl-2 pb-1",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }